import emailModalTemplate from '../../../pages/guestlists/components/messages/show-email-modal.tpl.html';

export default class ContactMessagesSmallComponentController {
    constructor(Alert, $http, $scope, $state, $stateParams, $uibModal, $rootScope, Acl, Messages) {
        this.alert = Alert;
        this.api = $http;
        this.state = $state;
        this.modal = $uibModal;
        this.scope = $scope;
        this.params = _.cloneDeep($stateParams);
        this.acl = Acl;
        this.messagesStore = Messages;
        this.currentStore = null;
        this.contact = null;
        this.currentMessages = [];

        this.loading = true;
        this._initWatchers();
        // this._loadGuests();
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.contact;
        }, () => {
            if (this.contact) {
                this._loadMessages();
            }
        })
    }

    _loadMessages() {
        this.loading = true;
        this.currentGuests = [];
        this.currentStore = this.messagesStore.reset({
            persist: false,
            listview: 'Contact' + this.contact.id + 'Messages'
        });

        this.currentStore.commit('setPermanentFilters', {
            recipient_id: this.contact.id,
            recipient_type: 'contact',
        });
        this.currentStore.commit('setVisible', [
            'subject',
            'status',
            'created_at'
        ]);
        this.currentStore.commit('addAction', {
            key: 'details',
            text: 'Details',
            class: 'btn btn-info btn-simple btn-xs',
            icon: 'fa fa-search',
            level: 'row',
            action: this.showMessage
        });

        this.currentStore.commit('setVm', this);

        this.currentStore.dispatch('getDefinitions').then(() => {
            this.currentStore.dispatch('getData').then(() => {
                this.currentMessages = this.currentStore.state.data;
                this.loading = false;
            })
        });
    }

    showMessage(message) {
        this.modal.open({
            animation: true,
            size: 'lg',
            templateUrl: emailModalTemplate,
            controller: ['$sce', '$uibModalInstance', 'email', 'Message', function ($sce, $uibModalInstance, email, Message) {
                var vm = this;
                vm.message = email;
                Message.one(email.id).get({include: 'recipient,template'}).then(function (message) {
                    vm.message = message;
                }, function (error) {
                });

                vm.cancel = function () {
                    $uibModalInstance.dismiss();
                }
            }],
            resolve: {
                email: function () {
                    return message;
                }
            },
            controllerAs: 'email'
        });
    }
}

ContactMessagesSmallComponentController.$inject = [
    'Alert',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$uibModal',
    '$rootScope',
    'Acl',
    'Messages'
];



// WEBPACK FOOTER //
// ./src/app/components/components/contact-messages-small/controller.js